import {
  Inserter,
  Wrapper,
  SessionRole,
  PartMenu,
  DragAndDropContext,
  RouterToTopOnNav,
  Pointer,
  ExtensionView,
} from "nystem-components";
import "./index.css";

const Index = () => (
  <>
    <ExtensionView type="background">
      <SessionRole userrole="logged-in">
        <Inserter source="/video/extension" />
      </SessionRole>
    </ExtensionView>
    <ExtensionView type="content">
      <Inserter source="/video/content" />
    </ExtensionView>
    <ExtensionView type="popup web">
      <DragAndDropContext>
        <Pointer />
        <RouterToTopOnNav />
        <SessionRole userrole="logged-out">
          <Inserter className="max-w-6xl m-auto p-3 text-gray-500" match="*" source="/adminUser/login" />
        </SessionRole>
        <SessionRole userrole="logged-in">
          <PartMenu />
          <Inserter match="*" source="/adminUser/logndebug" className="max-w-6xl m-auto" />
          <Wrapper renderAs="main" className="bg-black text-primary mt-12">
            <Inserter match="/popup.html" source="/video/incoming" />
            <Inserter match="/" source="/video/incoming" className="max-w-6xl m-auto" />
            <Inserter match="/category*" className="max-w-6xl m-auto" />
            <Inserter match="/tag*" className="max-w-6xl m-auto" />
            <Inserter match="/video/player" />
            <Inserter match="/video/watchLater" className="max-w-6xl m-auto" />
            <Inserter match="/video/view*" className="max-w-6xl m-auto" />
            <Inserter match="/video/tmp*" className="max-w-6xl m-auto" />
            <Inserter match="/video/list" className="max-w-6xl m-auto" />
            <Inserter match="/video/all" className="max-w-6xl m-auto" />
            <Inserter match="/video/incoming" className="max-w-6xl m-auto" />
            <Inserter match="/video/input/*" className="max-w-6xl m-auto" />
            <Inserter match="/archivedVideo/input/*" className="max-w-6xl m-auto" />
            <Inserter match="/archivedVideo/all" className="max-w-6xl m-auto" />
          </Wrapper>
        </SessionRole>
      </DragAndDropContext>
    </ExtensionView>
  </>
);
export default Index;
